import React from "react";

const Resume = ({ data }) => {
  if (!data) {
    return null;
  }

  const visibleWork = (data.work || []).filter((work) => !work.hidden);

  return (
    <>
      <section id="experience" className="experience-section section-shell">
        <div className="section-heading-row" data-reveal>
          <div>
            <p className="section-kicker">Experience</p>
            <h2>Full-stack ownership from interface to infrastructure.</h2>
          </div>
          <p className="section-support">
            I lead the work across product discovery, implementation,
            integrations, deployment, and the details that keep systems reliable
            in production.
          </p>
        </div>

        <div className="experience-list">
          {visibleWork.map((work, index) => (
            <article
              className="experience-entry"
              key={`${work.company}-${work.title}`}
              data-reveal
              style={{ "--reveal-delay": `${index * 70}ms` }}
            >
              <div className="experience-meta">
                <span>{work.years}</span>
                <span className="entry-number">0{index + 1}</span>
              </div>

              <div className="experience-content">
                <p className="experience-company">
                  {work.link ? (
                    <a href={work.link} target="_blank" rel="noopener noreferrer">
                      {work.company}
                    </a>
                  ) : (
                    work.company
                  )}
                </p>
                <h3>{work.title}</h3>
                <p>{work.description}</p>
                {work.focus ? (
                  <ul className="experience-focus">
                    {work.focus.map((item) => (
                      <li key={item}>{item}</li>
                    ))}
                  </ul>
                ) : null}
              </div>
            </article>
          ))}
        </div>
      </section>

      <section id="skills" className="skills-section section-shell">
        <div className="section-heading-row" data-reveal>
          <div>
            <p className="section-kicker">Capabilities</p>
            <h2>A stack shaped by product complexity.</h2>
          </div>
          <p className="section-support">{data.skillmessage}</p>
        </div>

        <div className="skills-grid">
          {(data.skills || []).map((skillGroup, index) => (
            <article
              className="skill-group"
              key={skillGroup.category}
              data-reveal
              style={{ "--reveal-delay": `${index * 60}ms` }}
            >
              <h3>{skillGroup.category}</h3>
              <ul className="skill-list">
                {skillGroup.items.map((skill) => (
                  <li key={skill}>{skill}</li>
                ))}
              </ul>
            </article>
          ))}
        </div>

        <div className="education-row" data-reveal>
          <p className="section-kicker">Education</p>
          <div>
            {(data.education || []).map((education) => (
              <article key={education.school}>
                <h3>{education.degree}</h3>
                <p>
                  {education.school} / {education.graduated}
                </p>
                <span>{education.description}</span>
              </article>
            ))}
          </div>
        </div>
      </section>
    </>
  );
};

export default Resume;
